<div class="formgrid grid">
    <div [class]="cssClass">
        <label class="mb1 font-bold">Selos Disponíveis: <span
                class="font-bold">{{listWoNotarialSealOutput.length}}</span></label>
    </div>

    <div [class]="cssClass">
        <label class="mb1 font-bold">Selo Atual: <span class="font-bold">{{selectedItem.code}}</span></label>
    </div>
</div>